import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';

/*  KÉSZLETÉRTÉKELÉS – a módszer (FIFO / csúsztatott / havi súlyozott átlagár) évtől, a havi összesítő
 *  (nyitó, beszerzés, ELÁBÉ, hiány, többlet, záró), a cikkenkénti árrés, és a feladás a Könyvelésbe
 *  (kettős könyvvitel). A módszert a cég és a könyvelő is beállíthatja; feladni a könyvelőiroda tud.
 *  Backend: inventario-ertekeles.js. */
@Component({
  selector: 'app-inventario-ertekeles',
  templateUrl: './ertekeles.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class InventarioErtekelesComponent implements OnInit, OnDestroy {
  readonly HONAPOK = ['', 'január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];
  ev = new Date().getFullYear();
  evek: number[] = [];
  beall: any = null;            // /ertekeles – módszerek, beállítások, könyvelés
  ossz: any = null;             // /osszesito – havi és cikkenkénti
  feladas: any = null;          // /feladas – időszakonként
  ujModszer = { ev: new Date().getFullYear(), modszer: 'csusztatott' };
  konyv: any = null;            // a könyvelési beállítás szerkesztett példánya
  fut = false;
  private sub?: Subscription;
  constructor(public inv: InventarioService, private toast: ToastController, private alert: AlertController) {
    const most = new Date().getFullYear();
    for (let e = most + 1; e >= most - 5; e--) this.evek.push(e);
  }
  get u() { return this.inv.aktiv.ugyfelId; }
  /** Könyvelői jog a cég Könyvelésében (a kiszolgáló dönti el) – ez kell a feladáshoz és a számlák beállításához. */
  get konyvelo() { return !!this.beall?.konyvelhet; }
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) return;
    try {
      this.beall = await this.inv.get(`/ertekeles/${this.u}`);
      this.konyv = { ...this.beall.konyveles };
      this.ujModszer = { ev: this.beall.valasztott ? new Date().getFullYear() + 1 : new Date().getFullYear(), modszer: this.beall.valasztott ? this.beall.kovetkezo : 'csusztatott' };
    } catch { this.beall = null; }
    await this.evFrissit();
  }
  async evFrissit() {
    if (!this.u) return;
    try { this.ossz = await this.inv.get(`/osszesito/${this.u}?ev=${this.ev}`); } catch { this.ossz = null; }
    try { this.feladas = await this.inv.get(`/feladas/${this.u}?ev=${this.ev}`); } catch { this.feladas = null; }
  }
  modszerek(): { kulcs: string; nev: string }[] { return Object.entries(this.beall?.modszerek || {}).map(([kulcs, nev]) => ({ kulcs, nev: String(nev) })); }
  konyvModok(): { kulcs: string; nev: string }[] { return Object.entries(this.beall?.konyveles_modok || {}).map(([kulcs, nev]) => ({ kulcs, nev: String(nev) })); }

  async modszerMent() {
    const nev = this.beall?.modszerek?.[this.ujModszer.modszer];
    const a = await this.alert.create({
      header: 'Értékelési módszer',
      message: `${this.ujModszer.ev}-tól: ${nev}. A módszer a számviteli politika része, és következetesen kell alkalmazni – évközben ne válts. A rendszer a ${this.ujModszer.ev}. év mozgásait ennek megfelelően újraértékeli.`,
      buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Beállítom', role: 'ok' }],
    });
    await a.present();
    if ((await a.onDidDismiss()).role !== 'ok') return;
    this.fut = true;
    try { await this.inv.post(`/ertekeles/${this.u}/modszer`, this.ujModszer); this.ok('Beállítva, a készlet újraértékelve.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; }
  }
  async konyvMent() {
    this.fut = true;
    try { await this.inv.post(`/ertekeles/${this.u}/konyveles`, this.konyv); this.ok('Mentve.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; }
  }
  idoszakNev(i: any) { return i.ho ? this.HONAPOK[i.ho] : `${this.ev}. év (év végi készletváltozás)`; }
  async felad(i: any) {
    if (i.feladva) {
      const a = await this.alert.create({ header: 'Újrafeladás', message: `A(z) ${i.bizonylatszam} bizonylat törlődik a Könyvelésből, és a mostani összegekkel újra elkészül.`,
        buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Újrafeladás', role: 'ok' }] });
      await a.present();
      if ((await a.onDidDismiss()).role !== 'ok') return;
    }
    this.fut = true;
    try {
      const r: any = await this.inv.post(`/feladas/${this.u}`, { ev: this.ev, ho: i.ho });
      this.ok(r.ures ? 'Ebben az időszakban nincs feladandó összeg.' : `Feladva a Könyvelésbe: ${r.bizonylatszam}`);
      await this.evFrissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; }
  }
  async visszavon(i: any) {
    this.fut = true;
    try { await this.inv.del(`/feladas/${this.u}/${this.ev}/${i.ho}`); this.ok('A bizonylat törölve a Könyvelésből.'); await this.evFrissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; }
  }
  szam(v: any) { return v == null || v === '' ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
  ft(v: any) { return v == null ? '' : Math.round(Number(v)).toLocaleString('hu-HU'); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5000, color: 'danger' })).present(); }
}
